module.exports = __webpack_public_path__ + "img/endIcon.ce274a0a.png";